import { useTranslation } from 'react-i18next';
import './GlowButton.css';

/**
 * GlowButton - Botón con efecto de neón/glow gamer
 * Variantes: primary (rosa), secondary (púrpura), accent (azul), ghost (transparente)
 */
export default function GlowButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  icon,
  type = 'button',
  className = '',
  id,
}) {
  return (
    <button
      id={id}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`glow-btn glow-btn--${variant} glow-btn--${size} ${fullWidth ? 'glow-btn--full' : ''} ${className}`}
    >
      {icon && <span className="glow-btn__icon">{icon}</span>}
      <span className="glow-btn__text">{children}</span>
    </button>
  );
}
